
import React, { useState, useEffect } from 'react';
import {useNavigate } from "react-router-dom";
import './Login.scss';
import GoogleLoginButton from './GoogleLoginButton';
import dataStore from '../../Store/store';
import Config from "../../core/constants/Config";
import Navbar from "../..//components/Navbar";
import Footer from "../../components/Footer";
import { observer } from "mobx-react";

const Login = observer(() =>  {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const [isFormVisible, setFormVisibility] = useState(false);
  const [data, setData] = useState(null);


  const fetchData = async () => {
    try {
      const response = await fetch(`${Config.API_BASE_URL}:8080/loginUser?email=sandeep&password=sandeep@123`);
      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    dataStore.setIsCheckout(false); // Set isCheckout to false when Layout component mounts
  }, []);

  const handleLogin = () => {
    fetchData();
  };

  return (
    <div>
   
       <Navbar />
    <div className="login-container bg-gradient-to-r from-[#b8860b] via-[#d4af37] to-[#ffcc33] bg-clip-text text-transparent">
      
      <h1>Login</h1>
      <div className="login-form">
        {/* <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button onClick={handleLogin}>Login</button> */}
      </div>
      <div className='createForm'>
     {/* <h6 className='reg-button' onClick={()=>navigate("/registrationForm")} >Create Account</h6>*/}
      </div>
      <div className='sign-with'>
      <p>-------- Or Sign-in with --------</p>
      </div>
      <GoogleLoginButton/>
      
    </div>
    <Footer/>
    </div>
  );
});

export default Login;
